import React, { useState, useEffect } from 'react';
import { apiGetCall, isResultOk } from './../../components/special/apiCall';
import { useLocale } from './../../components/special/LanguageProvider';
import ListHeader from './../../components/form/ListHeader';
import ListTable from './../../components/form/ListTable';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const TableTypeList = (props)  => {
  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);
  const { t } = useLocale();
  
  const loadList = async () =>{    
    const data = await apiGetCall(BASE_URL + '/admin/table/tabletype/summary');
    if (isResultOk(data, setListError, true)){
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);  
  
    return (    
      <div>      
        <ListHeader title={t("Forsendutöflur")}/>                          
        <ListTable
            error = {listError}
            isLoading = {listLoading}
            list = {list}
            colsettings = {['180px', '', '120px']}
            headers = {[
              t("Tegund"),
              t("Lýsing"),
              t("Fjöldi tafla"),                            
            ]}
            columns = {[
              (item => (<a href={"/admin/tables?tabletypeid=" + item.tableTypeID}>{item.name}</a>)),
              (item => (<span>{item.description}</span>)),
              (item => (<span>{item.numberOfTables}</span>)),              
            ]}
  
        />
    </div>
    );
};
